import mappings from './mappings';

const createElementFromHTML = htmlString => {
    const node = document.createRange().createContextualFragment(htmlString.trim());
    document.body.appendChild(node);
    return;
};

const trackings = (trackingType, state) => {
    if (!!mappings.find(mapping => mapping.widgetId === state.widget.widgetId)) {
        return mappings
            .find(mapping => mapping.widgetId === state.widget.widgetId)
            .trackings[trackingType].map(tracking => {
                if (tracking.includes(`timestamp`)) {
                    return tracking.replace(
                        new RegExp('timestamp', 'g'),
                        Math.random()
                            .toFixed(16)
                            .slice(2)
                            .toString()
                    );
                } else {
                    return tracking;
                }
            });
    } else {
        return [];
    }
};

export const appendTrackingPixels = (trackingType, state) =>
    trackings(trackingType, state).forEach(tracking => createElementFromHTML(tracking));
